import CarPayment from './CarPayment';

export default CarPayment;
